import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { useDeleteNews, useOneNews } from '../../../queries/news'
import Button from '../../core/Button/Button'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { InternalEndpoint } from '../../Internal'
import { useSnackBar } from '../hooks/useSnackBar'
import { NewsForm } from './NewsForm'

export const NewsDetails = () => {
  const params = useParams<{ id: string }>()
  const id = parseInt(params.id)
  const newsQuery = useOneNews({ id })
  const deleteNews = useDeleteNews()
  const navigate = useNavigate()
  const { dispatchSnack } = useSnackBar()

  const handleDelete = async () =>
    deleteNews.mutateAsync(
      { id },
      {
        onSuccess: () => {
          navigate(`/${InternalEndpoint}/news`)
          dispatchSnack('News item deleted!')
        }
      }
    )

  if (newsQuery.isError) {
    return <Navigate to={`/${InternalEndpoint}/news`} />
  }

  return (
    <>
      {newsQuery.isLoading && <CenteredLoadingAnimation />}
      {!newsQuery.isLoading && (
        <>
          <NewsForm news={newsQuery.data} />
          <Button
            type="dark"
            big
            css={{ backgroundColor: '$crimson05', marginTop: '16px' }}
            onClick={handleDelete}
            disabled={deleteNews.isLoading}
          >
            Delete news
          </Button>
        </>
      )}
    </>
  )
}
